var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHourglassIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 2048 2048",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M673.928 459.374c6.28229,-16.4291 -1.94528,-34.8425 -18.3744,-41.1248 -16.4291,-6.28229 -34.8425,1.94528 -41.1248,18.3744 -0.368504,0.961418 -128.589,321.77 230.121,587.376 -358.711,265.604 -230.49,586.414 -230.121,587.376 6.28229,16.4291 24.6957,24.6567 41.1248,18.3744 16.4291,-6.28229 24.6567,-24.6957 18.3744,-41.1248 -0.328347,-0.8563 -118.518,-296.078 243.658,-537.767 3.55985,-2.30433 6.71575,-5.35512 9.21733,-9.10749 9.80316,-14.7047 5.82993,-34.5733 -8.87481,-44.3764l-17.7508 26.6256 17.7496 -26.6256c-362.6,-241.733 -244.328,-537.143 -243.999,-538z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1433.57 436.623c-6.28229,-16.4291 -24.6957,-24.6567 -41.1248,-18.3744 -16.4291,6.28229 -24.6567,24.6957 -18.3744,41.1248 0.328347,0.8563 118.6,296.267 -243.999,538l17.7496 26.6256 -17.7508 -26.6256c-14.7047,9.80316 -18.678,29.6717 -8.87481,44.3764 2.50158,3.75237 5.65748,6.80315 9.21733,9.10749 362.176,241.689 243.986,536.911 243.658,537.767 -6.28229,16.4291 1.94528,34.8425 18.3744,41.1248 16.4291,6.28229 34.8425,-1.94528 41.1248,-18.3744 0.368504,-0.961418 128.589,-321.772 -230.121,-587.376 358.711,-265.605 230.49,-586.414 230.121,-587.376z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.062 255.998l883.876 0c26.4343,0 50.4414,10.7917 67.8249,28.1752 17.3835,17.3835 28.1752,41.3906 28.1752,67.8249l0 0.00236221c0,26.4319 -10.7917,50.4414 -28.1752,67.8249 -17.3835,17.3835 -41.3906,28.1752 -67.8249,28.1752l-883.876 0c-26.4343,0 -50.4414,-10.7917 -67.8249,-28.1752 -17.3835,-17.3835 -28.1752,-41.3929 -28.1752,-67.8249l0 -0.00236221c0,-26.4343 10.7917,-50.4414 28.1752,-67.8249 17.3835,-17.3835 41.3906,-28.1752 67.8249,-28.1752zm883.876 64.0016l-883.876 0c-8.76615,0 -16.761,3.61063 -22.5744,9.42402 -5.81339,5.81339 -9.42402,13.8083 -9.42402,22.5744l0 0.00236221c0,8.76615 3.61063,16.761 9.42402,22.5744 5.81339,5.81339 13.8083,9.42402 22.5744,9.42402l883.876 0c8.76615,0 16.761,-3.61063 22.5744,-9.42402 5.81339,-5.81339 9.42402,-13.8083 9.42402,-22.5744l0 -0.00236221c0,-8.76615 -3.61063,-16.761 -9.42402,-22.5744 -5.81339,-5.81339 -13.8083,-9.42402 -22.5744,-9.42402z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.062 1600l883.876 0c26.4343,0 50.4414,10.7917 67.8249,28.1752 17.3835,17.3835 28.1752,41.3929 28.1752,67.8249l0 0.00236221c0,26.4343 -10.7917,50.4414 -28.1752,67.8249 -17.3835,17.3835 -41.3906,28.1752 -67.8249,28.1752l-883.876 0c-26.4343,0 -50.4414,-10.7917 -67.8249,-28.1752 -17.3835,-17.3835 -28.1752,-41.3906 -28.1752,-67.8249l0 -0.00236221c0,-26.4319 10.7917,-50.4414 28.1752,-67.8249 17.3835,-17.3835 41.3906,-28.1752 67.8249,-28.1752zm883.876 64.0016l-883.876 0c-8.76615,0 -16.761,3.61063 -22.5744,9.42402 -5.81339,5.81339 -9.42402,13.8083 -9.42402,22.5744l0 0.00236221c0,8.76615 3.61063,16.761 9.42402,22.5744 5.81339,5.81339 13.8083,9.42402 22.5744,9.42402l883.876 0c8.76615,0 16.761,-3.61063 22.5744,-9.42402 5.81339,-5.81339 9.42402,-13.8083 9.42402,-22.5744l0 -0.00236221c0,-8.76615 -3.61063,-16.761 -9.42402,-22.5744 -5.81339,-5.81339 -13.8083,-9.42402 -22.5744,-9.42402z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 754.803,
    cy: 703.999,
    r: 31.9996
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 862.482,
    cy: 703.999,
    r: 31.9996
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 970.161,
    cy: 703.999,
    r: 31.9996
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1077.84,
    cy: 703.999,
    r: 31.9996
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1185.52,
    cy: 703.999,
    r: 31.9996
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1293.2,
    cy: 703.999,
    r: 31.9996
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 808.642,
    cy: 799.999,
    r: 31.9996
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 916.321,
    cy: 799.999,
    r: 31.9996
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1024,
    cy: 799.999,
    r: 31.9996
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1131.68,
    cy: 799.999,
    r: 31.9996
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1239.36,
    cy: 799.999,
    r: 31.9996
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 808.642,
    cy: 799.999,
    r: 31.9996
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 916.321,
    cy: 799.999,
    r: 31.9996
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1024,
    cy: 799.999,
    r: 31.9996
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1131.68,
    cy: 799.999,
    r: 31.9996
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1239.36,
    cy: 799.999,
    r: 31.9996
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 862.482,
    cy: 895.999,
    r: 31.9996
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 970.161,
    cy: 895.999,
    r: 31.9996
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1077.84,
    cy: 895.999,
    r: 31.9996
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1185.52,
    cy: 895.999,
    r: 31.9996
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 970.161,
    cy: 991.999,
    r: 31.9996
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1077.84,
    cy: 991.999,
    r: 31.9996
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1024,
    cy: 1088,
    r: 31.9996
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1024,
    cy: 1184,
    r: 31.9996
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1024,
    cy: 1280,
    r: 31.9996
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1293.2,
    cy: 1536,
    r: 31.9996
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1185.52,
    cy: 1536,
    r: 31.9996
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1077.84,
    cy: 1536,
    r: 31.9996
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 970.161,
    cy: 1536,
    r: 31.9996
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 862.482,
    cy: 1536,
    r: 31.9996
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 754.803,
    cy: 1536,
    r: 31.9996
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1239.36,
    cy: 1440,
    r: 31.9996
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1131.68,
    cy: 1440,
    r: 31.9996
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1024,
    cy: 1440,
    r: 31.9996
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 916.321,
    cy: 1440,
    r: 31.9996
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 808.642,
    cy: 1440,
    r: 31.9996
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1239.36,
    cy: 1440,
    r: 31.9996
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1131.68,
    cy: 1440,
    r: 31.9996
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1024,
    cy: 1440,
    r: 31.9996
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 916.321,
    cy: 1440,
    r: 31.9996
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 808.642,
    cy: 1440,
    r: 31.9996
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglassIcon);
export default __webpack_public_path__ + "static/media/hourglass-icon.dcc354824c6e62ecd986312306417f71.svg";
export { ForwardRef as ReactComponent };